import React from "react";

const Book = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="14"
      viewBox="0 0 20 18"
      fill="none"
    >
      <path
        d="M9.97559 1.73145C9.20215 0.817383 7.47949 0 5.45801 0C2.75977 0 0.580078 1.39746 0 2.72461V15.917C0 16.7783 0.5625 17.1123 1.18652 17.1123C1.65234 17.1123 1.91602 16.9717 2.21484 16.752C2.8125 16.2686 3.78809 15.7061 5.45801 15.7061C7.13672 15.7061 8.2793 16.2686 8.78906 16.6992C9.07031 16.9102 9.39551 17.1123 9.97559 17.1123C10.5557 17.1123 10.8721 16.8926 11.1621 16.6992C11.707 16.2949 12.8145 15.7061 14.4932 15.7061C16.1631 15.7061 17.1562 16.2773 17.7363 16.752C18.0352 16.9717 18.2988 17.1123 18.7646 17.1123C19.3887 17.1123 19.9512 16.7783 19.9512 15.917V2.72461C19.3711 1.39746 17.2002 0 14.4932 0C12.4717 0 10.7578 0.817383 9.97559 1.73145ZM1.90723 3.33105C2.14453 2.75098 3.44531 1.7666 5.45801 1.7666C7.4707 1.7666 8.81543 2.75977 9.02637 3.33105V14.9238C8.12109 14.2734 6.8291 13.9219 5.45801 13.9219C4.07812 13.9219 2.79492 14.2734 1.90723 14.9502V3.33105ZM18.0439 3.33105V14.9502C17.1562 14.2734 15.873 13.9219 14.4932 13.9219C13.1221 13.9219 11.8301 14.2734 10.9248 14.9238V3.33105C11.1357 2.75977 12.4805 1.7666 14.4932 1.7666C16.5059 1.7666 17.8066 2.75098 18.0439 3.33105Z"
        fill="#5E5E5F"
      />
    </svg>
  );
};

export default Book;
